import { FailureSeverity } from '../types/FailureSeverity';
import { ValidationFailure } from '../types/ValidationFailure';

export const createWarningFailure = (message: string, code = ''): ValidationFailure => {
  return {
    message,
    code,
    severity: FailureSeverity.Warning,
  };
};
